import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';
import { goal } from 'kodyl-js/tracking';
import {
  createBoligAgent,
  CREATE_SUCCESS,
  CREATE_FAIL
} from '../redux/modules/boligagents';

const INVALID_MAIL = 'invalid-mail';
const NO_EMAIL = 'no-email';
const ERROR = 'error';
const WRONG_USER_MAIL = 'wrong-user-email';
const NOUPDATE = 'nothing-to-update';
const EMAIL_EXISTS = 'email-in-use';

function getErrorMsg(status) {
  switch (status) {
    case 400:
      return WRONG_USER_MAIL;
    case 404:
      return NOUPDATE;
    case 406:
      return EMAIL_EXISTS;
    case 500:
      return EMAIL_EXISTS;
    default:
      return ERROR;
  }
}

@connect(
  ({ auth: { user }, boligagents }) => ({
    user,
    prefs: boligagents.sessionPrefs,
    boligagent: boligagents.current
  }),
  { createBoligAgent }
)
@i18n
class Signup extends Component {
  static propTypes = {
    area: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    const { user } = props;
    this.state = {
      response: false,
      validation: false,
      inputValue: (user && user.email) || '',
      error: false
    };

    this.messages = {
      [NO_EMAIL]: this.i18n('Email address is required'),
      [ERROR]: this.i18n(
        'An error occurred. Please try again or contact customer support.'
      ),
      [INVALID_MAIL]: this.i18n('Please enter a valid email'),
      [WRONG_USER_MAIL]: this.i18n(
        'Den angivne email matcher ikke din brugers email. Prøv at ændre emailen eller kontakt support.'
      ),
      [NOUPDATE]: this.i18n(
        'Din boligagent er allerede opdateret med angivne områder'
      ),
      [EMAIL_EXISTS]: this.i18n(
        'Tillykke! Din boligagent er oprettet. Nu mangler vi kun din bekræftigelse. Log ind og du er klar.'
      )
    };
  }

  componentWillReceiveProps(nextProps) {
    const { user } = nextProps;
    if (user) {
      this.setState({ inputValue: user.email });
    }
  }

  handleChange = event => {
    this.setState({ inputValue: event.target.value });
  };

  handleSubmit = event => {
    const { area } = this.props;
    const { email } = this.refs;
    event.preventDefault();
    this.props
      .createBoligAgent({
        prefs: [{ area: area.slug }],
        email: email && email.value
      })
      .then(action => {
        if (action.type === CREATE_FAIL) {
          this.setState({
            validation: getErrorMsg(action.error.response.status),
            error: true
          });
        }
        if (action.type === CREATE_SUCCESS) {
          const response = action.payload;
          this.setState({ response, validation: false, error: false });
          goal({ name: 'Lead' });
        }
        return action;
      });
  };

  render() {
    if (!this.props.area) {
      return null;
    }

    const { area, headline, user, boligagent } = this.props;
    const { validation, response, inputValue, error } = this.state;

    const status = response
      ? !response.STATUS || this.messages[EMAIL_EXISTS]
      : null;
    const isSignedUp =
      boligagent && boligagent.prefs
        ? Boolean(
            boligagent.prefs.filter(pref => pref.area === area.slug).length
          )
        : false;

    if (isSignedUp && !status) {
      return null;
    }

    return (
      <div className="boligagent-signup-block">
        <h3>
          {headline
            ? this.i18n('Be first to receive new dwellings in %s!', area.label)
            : area.label
            ? this.i18n('Still looking for your new home in %s?', area.label)
            : this.i18n('Still looking for your new home?')}
        </h3>
        <div className="row">
          <div
            className="col-sm-7"
            dangerouslySetInnerHTML={{
              __html: this.i18n(
                "Let the Boligninja help you! He'll send you an email whenever something new and interesting becomes available!"
              )
            }}
          />
          <div className="col-sm-5">
            {status === true ? (
              <div className="boligagent-signup-success">
                {this.i18n(
                  'Tillykke! Du vil nu modtage emails fra Boligninja, når nye lejeboliger i bliver ledige.'
                )}
              </div>
            ) : (
              <div>
                {status && (
                  <div className="boligagent-signup-success">{status}</div>
                )}
                <form
                  className="form"
                  onSubmit={this.handleSubmit}
                  autoComplete="on"
                  name="form"
                >
                  <div
                    className={`form-group${error ? ' has-error' : ''}`}
                    style={{ marginBottom: 0 }}
                  >
                    <input type="hidden" value={area.label} />
                    {user && user.email ? (
                      <button
                        className="btn btn-success email-signup-btn"
                        type="submit"
                      >
                        {this.i18n('Signup')}
                      </button>
                    ) : (
                      <div>
                        <div className="input-container">
                          <div className="input-group">
                            <div className="input-group-addon">@</div>
                            <input
                              className="form-control"
                              style={{ position: 'static' }}
                              type="email"
                              id="boligagent-email"
                              name="email"
                              ref="email"
                              required
                              value={inputValue}
                              onChange={this.handleChange}
                              placeholder={this.i18n(
                                'Type in your email address'
                              )}
                            />
                            <span className="input-group-btn">
                              <button className="btn btn-success" type="submit">
                                {this.i18n('Signup')}
                              </button>
                            </span>
                          </div>
                        </div>
                        {validation ? (
                          <p className="help-block">
                            {this.messages[validation]}
                          </p>
                        ) : null}
                      </div>
                    )}
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Signup;
